import type { EditorAPI } from '#packages/editorAPI';

export const openEmailMarketingPackagePicker = (
  editorAPI: EditorAPI,
  msid: string,
) => {
  const packagePickerUrl = `https://www.wix.com/wix-emails-plans?metaSiteId=${msid}`;
  window.open(packagePickerUrl, '_blank');
};
